import { ReactElement } from 'react';
import { Typography } from 'antd';

const { Title: AntTitle, Paragraph } = Typography;

const Title = (): ReactElement => {
  return (
    <>
      <AntTitle level={1}>架電履歴</AntTitle>
      <Paragraph type='secondary'>架電履歴を確認することができます。</Paragraph>
    </>
  );
};

export default Title;
